const autoExecuteAsync = (asyncFn: () => void): void => {
    ;(async () => {
        await asyncFn()
    })()
}

export { autoExecuteAsync }
